import Util from "./lib/util"

export default class WaveImage {
  constructor(canvas) {
    this.canvas = canvas
    this.off_ctx = this.canvas.getContext("2d")
    this.imgData = this.off_ctx.createImageData(this.canvas.width, this.canvas.height)
    this.util = new Util()
    this.offx = 0
    this.offy = 0
    this.zoom = 0
    this.trig = 0
  }

  compute(x, y, arr1, arr2) {
    let val = arr1[(x << 1) & 0xFF] * arr2[(y << 1) & 0xFF]
    return {
      r: (this.util.sin(Math.PI * val) + 1) * 0.5 * 0.1 + 0.1,
      g: (this.util.sin(Math.PI * val) + 1) * 0.5 * 0.3 + 0.3,
      b: (this.util.sin(Math.PI * val) + 1) * 0.5 * 0.4 + 0.2,
    }
  }

  updateImage(f1, f2) {
    console.log("update image")
    let width = this.canvas.width
    let height = this.canvas.height
    for (let x = 0; x < width; x++) {
      for (let y = 0; y < height; y++) {
        let color = this.compute(x, y, f1, f2)
        this.imgData.data[4 * (y * width + x)] = color.r * 255
        this.imgData.data[4 * (y * width + x) + 1] = color.g * 255
        this.imgData.data[4 * (y * width + x) + 2] = color.b * 255
        this.imgData.data[4 * (y * width + x) + 3] = 255
      }
    }
    this.off_ctx.putImageData(this.imgData, 0, 0)
  }


}

